import { render, staticRenderFns } from "./DlgPostsNewMobile.vue?vue&type=template&id=20232259&scoped=true&"
import script from "./DlgPostsNewMobile.vue?vue&type=script&lang=ts&"
export * from "./DlgPostsNewMobile.vue?vue&type=script&lang=ts&"
import style0 from "./DlgPostsNewMobile.vue?vue&type=style&index=0&id=20232259&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20232259",
  null
  
)

export default component.exports